import { Space } from "~/lib/types";
import { RiskFactorsConfiguration } from "~/pages/security-model/RiskFactorsConfiguration";

type Props = {
  space: Space;
};

const RiskFactorsEntryPage = ({ space }: Props) => {
  return <RiskFactorsConfiguration space={space} />;
};

export default RiskFactorsEntryPage;
